import type { ProductFeatureGroup } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";

interface ProductFeatureGroupsProps {
  groups: ProductFeatureGroup[];
  locale: PepLocale;
  title?: string;
}

export function ProductFeatureGroups({ groups, locale, title }: ProductFeatureGroupsProps) {
  if (!groups.length) return null;

  return (
    <section className="mb-5">
      <h2 className="h4 fw-bold mb-4">
        {title ?? (locale === "en" ? "Capabilities" : "Capacités métier")}
      </h2>
      <div className="row g-4">
        {groups.map((group) => {
          const groupTitle =
            locale === "en" && group.titleEn ? group.titleEn : group.titleFr;
          return (
            <div className="col-md-6" key={group.titleFr}>
              <div className="pep-product-feature-group h-100">
                <h3 className="h6 fw-bold mb-3">{groupTitle}</h3>
                <ul className="list-unstyled mb-0 pep-product-feature-group__list">
                  {group.features.map((feature) => (
                    <li key={feature}>
                      <span className="pep-product-feature-group__check" aria-hidden>
                        ✓
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
